import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IncidentServices, CommonServices, IntegrationServices} from '../../shared/services/src/api';
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
import { SystemId } from '../../shared/enums/systemId';
import {LanguageUtils} from '../../shared/utils/src/language.utils';
import {EventType} from '../../shared/enums/event-type.enum';
import {sort} from '@syncfusion/ej2-charts';

export interface LangChangeEvent {
    lang: string;
    translations: any;
}

@Component({
    selector: 'activity-history',
    templateUrl: './activity-history.component.html',
    styleUrls: [
        './container.activity-history.scss'
    ],
    providers: [IntegrationServices]
})


export class ActivityHistoryComponent implements OnChanges, OnInit, OnDestroy {
    // @Input() public tcktNo = 0;
    // @Input() public itgrNm: string;
    @ViewChild('responders') responders;
    @Input() public DetailData: any;
    private isAbleApply = true;
    public activityHistorySelectedTab = 'all';

    public rawHistoryList: Array<any> = [];
    public historyList: Array<any> = [];
    public selectedData;

    public rows: Array<any> = [];

    /** 페이지 네이션 옵션 설정 **/
    public itemsPerPage = 10;
    public totalCount = 0;
    public currentPage = 1;
    public selectOptions = [10, 20, 50];

    private TableData: any;
    private isTabChanged = false;

    private params = {};
    private historyMsgType = '';

    private subscription: Subscription;
    constructor( private incidentServices: IncidentServices,
                 private commonServices: CommonServices,
                 private translate: TranslateService,
                 private integrationServices: IntegrationServices) {
    }

    ngOnInit() {
        this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.isAbleApply = false;
            this.Apply();
            this.responders.Apply();
        });
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
        const chng = changes['DetailData'];
        // const tabChange = changes['activityHistorySelectedTab '];

        // const targetChange = changes['contentTarget']
        // const tabChange = changes['selectedTab'];
        //
        // if ((targetChange || tabChange ) && this.lnbDataLoading === true && this.selectedTab === 'escalationRule') {
        //     this.getEscalationInfo();
        // }

        if (chng !== undefined) {
            if (chng.currentValue !== undefined && (chng.currentValue !== chng.previousValue)) {
                if (this.isAbleApply) {
                    this.activityHistorySelectedTab = 'all';
                    this.Apply();
                }
            }
        }

    }

    /** 페이지 이동 이벤트 **/
    public onPageChanged(event: any): void {
        if (event.currentPage !== 1) {
            this.currentPage = event.currentPage;
            this.isAbleApply = true;
            this.Apply();
        }
        if (event.currentPage === 1 && !this.isTabChanged) {
            this.currentPage = event.currentPage;
            this.isAbleApply = true;
            this.Apply();
        }
        this.isTabChanged = false;
    }

    /** 페이지 선택 이벤트 **/
    public onSelectChanged(event: any): void {
        this.itemsPerPage = event.itemsPerPage;
        this.currentPage = 1;
        this.isAbleApply = true;
        this.Apply();
    }

    /** 탭 이동시 호출 됨 **/
    activityHistoryChange(id) {
        this.activityHistorySelectedTab = id;

        if (this.currentPage === 1) {
            this.isTabChanged = true;
            this.isAbleApply = true;
            this.Apply();
        } else {
            this.isTabChanged = false;
            this.currentPage = 1;
        }
    }

    Apply() {
        this.historyList = [];
        this.rawHistoryList = [];

        let queryString = '?';
        queryString += 'page='     + this.currentPage;
        queryString += '&rows='     + this.itemsPerPage;
        queryString += `${(this.activityHistorySelectedTab === 'all') ? '' : '&type=' + this.activityHistorySelectedTab}`;
        queryString += '&oidx=regDt:desc';

        this.incidentServices.getActivityHistoryList(this.DetailData.tcktNo, queryString).then(async result => {
            if (result.status === 200) {
                this.TableData = result.json().data;
                this.totalCount = result.json().addInfo.total;
                this.rawHistoryList = this.TableData;

                //this.rawHistoryList.forEach(async data => {
                for (const data of this.rawHistoryList) { //순차 처리를 위해 foreach -> for of 로 변경
                    let histDtl = '';

                    if (data.histDtl) {
                        try {
                            // backslash 가 포함된 json string 의 경우 파싱 시 에러 발생하므로 replace 처리함
                            histDtl = JSON.parse(_.unescape(data.histDtl).replace(/\\/g, '\\\\').replace(/\n/g, '<br>'));
                        } catch (e) {
                            console.error(e);
                        }
                    }

                    const strCycle = this.translate.instant('MK.00643');
                    const strAfter = this.translate.instant('MK.00642');
                    const strRepeat = this.translate.instant('MK.00645');
                    const strStep = this.translate.instant('MK.00644');

                    const activity = new Activity();
                    activity.setData(data);
                    activity.setHistDtl(histDtl);
                    activity.setTranslate(this.translate);
                    activity.setCommon(this.commonServices);
                    activity.setIntegration(this.integrationServices);
                    activity.setStrCycle(strCycle);
                    activity.setStrAfter(strAfter);
                    activity.setStrRepeat(strRepeat);
                    activity.setStrStep(strStep);
                    activity.setItgrApplDispNm(this.DetailData.itgrApplDispNm);
                    data.regDatetime = moment(data.regDt).format('YYYY-MM-DD');
                    data.regTime = moment(data.regDt).format('HH:mm');


                    /*
                    EVTTY010	Assigned to me
                    EVTTY020	Status Changed
                    EVTTY030	Escalated
                    EVTTY040	Incident Created (Auto)
                    EVTTY050	Registered Escalation Member
                    EVTTY060	Incident Created (Manual)
                    EVTTY070	Add Comment
                    EVTTY080	Merge Incident
                    EVTTY090	Merged into Incident
                    EVTTY100	Related Incident Create
                    EVTTY110	Related Incident Modify
                    EVTTY120	Modify Incident Urgency
                    */
                    /*
                    this.rawCommentList = this.TableData.filter(history => history.eventTypeCd === 'EVTTY070');
                    this.assigneeList = this.TableData.filter(history => history.eventTypeCd === 'EVTTY010');
                    this.rawActivityList = this.TableData.filter(history => history.eventTypeCd !== 'EVTTY010' && history.eventTypeCd !== 'EVTTY070');
                    */

                    let tmpDisp = '';

                    await activity[data.eventTypeCd](this.activityHistorySelectedTab);
                    this.historyMsgType = activity.result.historyMsgType;
                    this.params = activity.result.params;


                    // if (this.activityHistorySelectedTab === 'cmmt') {
                    //     this.getCmmt(data);
                    // } /*else if (this.activityHistorySelectedTab === 'assign') {
                    //     this.getAssign(data, histDtl);
                    // } */else if (this.activityHistorySelectedTab === 'acvt') {
                    //     // this.getAcvt(data, histDtl);
                    //     //this.historyMsgType = activity[data.eventTypeCd]().historyMsgType;
                    //     //this.params = activity[data.eventTypeCd]().params;
                    //     const histData = activity[data.eventTypeCd](this.activityHistorySelectedTab);
                    //     this.historyMsgType = histData.historyMsgType;  //Activity Class 가 두번 호출되어 hisdata라는 파라미터를 사용하도록 변경
                    //     this.params = histData.params;
                    // } else {
                    //     if (data.eventTypeCd === 'EVTTY070') {
                    //         this.getCmmt(data);
                    //     } /*else if (data.eventTypeCd === 'EVTTY010') {
                    //         this.getAssign(data, histDtl);
                    //     }*/ else {
                    //         const histData = activity[data.eventTypeCd](this.activityHistorySelectedTab);
                    //         //this.historyMsgType = activity[data.eventTypeCd](this.activityHistorySelectedTab).historyMsgType;
                    //         //this.params = activity[data.eventTypeCd](this.activityHistorySelectedTab).params;
                    //         this.historyMsgType = histData.historyMsgType;  //Activity Class 가 두번 호출되어 hisdata라는 파라미터를 사용하도록 변경
                    //         this.params = histData.params;
                    //     }
                    // }

                    let _type = '';
                    if (data.eventTypeCd === 'EVTTY010') {
                        _type = 'assigned';
                        // } else if (data.eventTypeCd === 'EVTTY020') {
                        //     _type = 'maintenance';
                        // } else if (data.eventTypeCd === 'EVTTY030' || data.eventTypeCd === 'EVTTY040' || data.eventTypeCd === 'EVTTY050') {
                        //     _type = 'change_history';
                    } else if (data.eventTypeCd === 'EVTTY070') {
                        _type = 'comment';
                    } else if (data.eventTypeCd === 'EVTTYR010'||data.eventTypeCd === 'EVTTYR020'||data.eventTypeCd === 'EVTTYR030'||data.eventTypeCd === 'EVTTYR040'||data.eventTypeCd === 'EVTTYR050') {
                        _type = 'runbook';
                    } else {
                        _type = 'activity';
                    }

                    if (this.historyMsgType !== '') {
                        if (this.params['regrNo'] === SystemId.Integration) {
                            if (this.params['statusCd2'] === '10003') {
                                if (this.params['methodCd'] === 'CHTC070') {
                                    tmpDisp = this.translate.instant('MK.01615', this.params); // 인티그레이션 서비스에 의해 인시던트 상태가 종료되었습니다.
                                } else {
                                    tmpDisp = this.translate.instant('MK.00948', this.params); // 인티그레이션 서비스에 의해 인시던트 상태가 종료되었습니다.
                                }
                            } else if (this.params['statusCd2'] === '10002') {
                                tmpDisp = this.translate.instant('MK.01613', this.params); // 인티그레이션 서비스에 의해 인시던트 상태가 확인되었습니다.
                            }
                        } else {
                            if (this.params['methodCd'] === 'CHTC110') {
                                tmpDisp = this.translate.instant('MK.01615', this.params);
                            } else {
                                tmpDisp = this.translate.instant(this.historyMsgType, this.params);
                            }
                        }


                        if (data.eventTypeCd === 'EVTTY030' && data.escalPlcyNm.indexOf('DummyEscalation') > -1) {
                            // DummyEscalation 이 종료된 경우 활동이력에 표시하지 않음.
                        } else {
                            this.historyList.push(
                                {
                                    regDatetime: data.regDatetime,
                                    regTime: data.regTime,
                                    dispNm: tmpDisp,
                                    activityType: _type,
                                    histNo: data.tcktActvHistNo
                                }
                            );
                        }
                    }
                    //});
                }
            }
        });

        setTimeout(() => {
            this.isAbleApply = true;
        }, 3000);
    }

    // getCmmt(data) {
    //     this.params = {regrNm: data.regrNm, comment: data.textSbst.replace(/\\"/g, '"')};
    //     this.historyMsgType = 'MK.01566';
    // }
    /*getAssign(data, histDtl) {
        switch (histDtl[0].MDF_FILD_NM) {
            case '':
                this.params = {userNm: data.regrNm};
                this.historyMsgType = 'MK.00667';
                return;
            case 'USER_NO':
                this.params = {userNm1: histDtl[0].MDF_AF_SBST_NM, userNm2: data.regrNm};
                this.historyMsgType = 'MK.00666';
                break;
            default :
                this.historyMsgType = '';
                break;
        };
    }*/

    openResponder(evt, activity) {
        if(activity.activityType==='comment'){
            return;
        }

        const href = evt.target.getAttribute('href');
        if (href) {
            evt.preventDefault();
            this.selectedData = href;
            $.magnificPopup.open({
                items: {
                    src: '#responderPopup',
                },
            });

        }
    }
}

/*
Activity는 너무 복잡하니까...
그나마 보기 쉽게 Class로 빼자
*/
class ActivityHistoryResult {
    data;
    histDtl;
    translate;
    strCycle;
    strAfter;
    strRepeat;
    strStep;
    result = {
        'historyMsgType': '',
        'params': {}
    };
    itgrApplDispNm;
    common;
    integration;

    setData(data) {
        this.data = data;
    }
    setTranslate(translate) {
        this.translate = translate;
    }
    setHistDtl(histDtl) {
        this.histDtl = histDtl;
    }

    setStrCycle(strCycle) {
        this.strCycle = strCycle;
    };
    setStrAfter(strAfter) {
        this.strAfter = strAfter;
    };

    setStrRepeat(strRepeat) {
        this.strRepeat = strRepeat;
    };
    setStrStep(strStep) {
        this.strStep = strStep;
    };
    setItgrApplDispNm(itgrApplDispNm) {
        this.itgrApplDispNm = itgrApplDispNm;
    };
    setCommon(common) {
        this.common = common;
    };
    setIntegration(integration) {
        this.integration = integration;
    };
}

class Activity extends ActivityHistoryResult {
    langCd = LanguageUtils.getLangCode();
    /* Assigned to me */
    EVTTY010 = function(selectedTab) { // 담당자 변경 팝업에서 담당자 지정 액션
        let msgType = '';
        const regrNm  = this.data.regrNm;
        const regrNo  = this.data.regrNo;
        let rspdNm;
        let respNo;

        const userNoData = _.find(this.histDtl, ['MDF_FILD_NM', 'USER_NO']);
        if (userNoData) {
            msgType += '1';
            respNo = userNoData['MDF_AF_SBST'];
            rspdNm = userNoData['MDF_AF_SBST_NM'];

            //지정된 담당자와 지정한 사람이 같은경우 (본인을 asignee로 등록한 경우)
            if (regrNo.toString() === respNo) {
                msgType += '2';
            }
        }

        const historyMsgType = `history_acvt_type_evtty010_${msgType}`;
        switch (historyMsgType) {
            case 'history_acvt_type_evtty010_1':   // {{regrNm}} 님이 {{rspdNm}} 님을 담당자로 지정했습니다.{{addCntnt}}
                this.result.historyMsgType = 'MK.01568';
                break;
            case 'history_acvt_type_evtty010_12':  // {{rspdNm}} 님이 담당자로 지정되었습니다.
                this.result.historyMsgType = 'MK.01569';
                break;
        }
        const chTypeCd = _.find(this.histDtl, ['MDF_FILD_NM', 'CH_TYPE_CD']);
        const addCntnt = chTypeCd === undefined ? '' : (this.langCd === 'zh' ? `<strong>[${chTypeCd['MDF_AF_SBST_NM']}]</strong>` : ` <strong>[${chTypeCd['MDF_AF_SBST_NM']}]</strong>`);

        //전체 tab인경우 wrkflwStepNo 이면(상태변경에 의한 담당자 지정)이면 null처리
        const wrkflwStepNo = _.find(this.histDtl, ['MDF_FILD_NM', 'WRKFLW_STEP_NO']);
        const cyclOrdrNo = _.find(this.histDtl, ['MDF_FILD_NM', 'CYCL_ORDR_NO']);
        if (selectedTab === 'all' && (wrkflwStepNo || cyclOrdrNo)) {
            this.result.historyMsgType = '';
        }

        this.result.params = {
            regrNm: regrNm,
            rspdNm: rspdNm,
            addCntnt: addCntnt
        };

        return this.result;
    };
    /* Status Changed */
    EVTTY020 = function() {
        let msgType = '';
        let status1;
        let status2;
        let statusCd2;
        let rspdNm;
        const regrNm = this.data.regrNm;

        // 상태 변경(전후 상태를 가져오자)
        const wrkflwStepNo = _.find(this.histDtl, ['MDF_FILD_NM', 'WRKFLW_STEP_NO']);
        if (wrkflwStepNo) {
            msgType += '1';
            status1 = wrkflwStepNo['MDF_BF_SBST_NM'];
            status2 = wrkflwStepNo['MDF_AF_SBST_NM'];
            statusCd2 = wrkflwStepNo['MDF_AF_SBST'];
        }
        const statusStr = this.translate.instant('MK.01578', {'status1': status1, 'status2': status2});

        // 담당자?!
        const userNo = _.find(this.histDtl, ['MDF_FILD_NM', 'USER_NO']);
        if (userNo) {
            msgType += '2';
            rspdNm = userNo['MDF_AF_SBST_NM'];
        }
        const rspdStr = this.translate.instant('MK.01576', {'rspdNm': rspdNm});

        // 에스컬레이션 중지!!
        const escalPlyActvTypeCd = _.find(this.histDtl, ['MDF_FILD_NM', 'ESCAL_PLY_ACTV_TYPE_CD']);
        if (escalPlyActvTypeCd) {
            msgType += '3';
        }
        const escalCloseStr = this.translate.instant('MK.01579');

        const chTypeCd = _.find(this.histDtl, ['MDF_FILD_NM', 'CH_TYPE_CD']);
        const methodStr = chTypeCd === undefined ? '' : (this.langCd === 'zh' ? `<strong>[${chTypeCd['MDF_AF_SBST_NM']}]</strong>` : ` <strong>[${chTypeCd['MDF_AF_SBST_NM']}]</strong>`);
        const methodCd = chTypeCd === undefined ? '' : chTypeCd['MDF_AF_SBST'];

        const responder = this.translate.instant('MK.00978');

        let btnLink = `<a href='/popup/escalation-policy-responders`;
            btnLink += `?tckNo=${this.data.trgtTcktNo}&tcktActvHistNo=${this.data.tcktActvHistNo}&companyId=${global['loginUser']['curCmpnId']}')`;
            btnLink += `onclick="window.open(this.href, '_blank','width=1200, height=500, menubar=no, status=no')" target='_blank'>${responder}</a>`;
        let addCntnt = '';

        const historyMsgType = `history_acvt_type_evtty020_${msgType}`;
        switch (historyMsgType) {
            case 'history_acvt_type_evtty020_1':       /* 상태변경 */
                // {{regrNm}} 님이 상태를 {{status2}}(으)로 변경했습니다./ - {{method}} [응답자 버튼]
                addCntnt = `${methodStr}${btnLink}<br>${statusStr}`;
                break;
            case 'history_acvt_type_evtty020_12':      /* 상태변경 + 담당자 지정 */
                // {{regrNm}} 님이 상태를 {{status2}}(으)로 변경했습니다./ - {{method}} [응답자 버튼] <br> - 상태: {{status1}} → {{status2}} <br> - 담당자: {{regrNm}}
                addCntnt = `${methodStr}${btnLink}<br>${statusStr}<br>${rspdStr}`;
                break;
            case 'history_acvt_type_evtty020_13':      /* 상태변경 + 에스컬레이션 중지 */
                // {{regrNm}} 님이 상태를 {{status2}}(으)로 변경했습니다./ - {{method}} [응답자 버튼] <br> - 상태: {{status1}} → {{status2}} <br> - 에스컬레이션 실행: 종료
                addCntnt = `${methodStr}${btnLink}<br>${statusStr}<br>${escalCloseStr}`;
                break;
            case 'history_acvt_type_evtty020_123':     /* 상태변경 + 담당자 지정 + 에스컬레이션 중지 */
                // {{regrNm}} 님이 상태를 {{status2}}(으)로 변경했습니다./ - {{method}} [응답자 버튼] <br> - 상태: {{status1}} → {{status2}} <br> - 담당자: {{regrNm}} <br> - 에스컬레이션 실행: 종료
                addCntnt = `${methodStr}${btnLink}<br>${statusStr}<br>${rspdStr}<br>${escalCloseStr}`;
                break;
        }

        let addCntnt2 = '';
        if(methodCd === 'CHTC110'){
            addCntnt2 = `${btnLink}<br>${statusStr}`;
        } else {
            addCntnt2 = `${methodStr}${btnLink}<br>${statusStr}`;
        }

        // {{regrNm}} 님이 상태를 {{status2}}(으)로 변경했습니다.
        this.result.historyMsgType = 'MK.01571';
        this.result.params = {
            regrNm: regrNm,
            status2: status2,
            statusCd2: statusCd2,     // by integration service
            addCntnt: addCntnt,
            regrNo: this.data.regrNo, // by integration service
            addCntnt2: addCntnt2 ,
            methodCd: methodCd// by integration service
        };

        return this.result;
    };
    /* Escalated */
    EVTTY030 = function() {
        const textSbst = JSON.parse(this.data.escalSnapshot);
        const repeatCnt = textSbst.calcReptCnt;      // 최종 알림 횟수
        const bfTimeCnt = textSbst.cyclOrdrNo;       // 이전 실행 횟수
        const bfStageCnt = textSbst.currStepOrdrNo;  // 이전 진행 단계
        let afTimeCnt = textSbst.cyclOrdrNo;         // 이후 실행 횟수
        let afStageCnt = textSbst.calcStepOrdrNo;    // 이후 진행 단계
        const stageRepeat = (textSbst.calcReptOrdrNo - 1) === 0 ? '' : this.translate.instant('MK.01581'); // '(단계 반복됨)' 텀 표시 여부
        let msgType = '';
        const escalPlyActvTypeCd = _.find(this.histDtl, ['MDF_FILD_NM', 'ESCAL_PLY_ACTV_TYPE_CD']);   // 에스컬레이션 여부
        const escalateStep = _.find(this.histDtl, ['MDF_AF_SBST', 'ESCALATE_STEP']);
        const repeatStep = _.find(this.histDtl, ['MDF_AF_SBST', 'REPEAT_STEP']);                      // 에스컬레이션 단계 반복 여부
        const rotateEscalation = _.find(this.histDtl, ['MDF_AF_SBST', 'ROTATE_ESCALATION']);          // 에스컬레이션 실행(전체 반복) 여부
        const repeatNotiAll = _.find(this.histDtl, ['MDF_AF_SBST', 'REPEAT_NOTI_ALL']);               // 최종 알림 여부
        const stopEscalation = _.find(this.histDtl, ['MDF_AF_SBST', 'STOP_ESCALATION']);              // 에스컬레이션 중지 여부
        const termEscalation = _.find(this.histDtl, ['MDF_AF_SBST', 'TERMINATE_ESCALATION']);         // 에스컬레이션 종료 여부

        let calcStepOrdrNo = textSbst.calcStepOrdrNo; // 응답자 팝업 URL 파라미터
        if (escalPlyActvTypeCd && escalateStep) {
            msgType += '1';
        }
        if (escalPlyActvTypeCd && repeatStep) {
            msgType += '1';
        }
        if (escalPlyActvTypeCd && rotateEscalation) {
            afTimeCnt = textSbst.nextCyclOrdrNo;
            afStageCnt = 1;
            calcStepOrdrNo = 1;
            msgType += '1';
        }
        if (escalPlyActvTypeCd && repeatNotiAll) {
            msgType += '2';
        }
        if (escalPlyActvTypeCd && stopEscalation) {
            msgType += '3';
        }
        if (escalPlyActvTypeCd && termEscalation) {
            msgType += '4';
        }

        const responder = this.translate.instant('MK.00978');
        let btnLink = `<a href='/popup/escalation-policy-responders`;
            btnLink += `?tckNo=${this.data.trgtTcktNo}&tcktActvHistNo=${this.data.tcktActvHistNo}`;
            btnLink += `&calcStepOrdrNo=${calcStepOrdrNo}&escalPlcyNm=${this.data.escalPlcyNm}&companyId=${global['loginUser']['curCmpnId']}')`;
            btnLink += `onclick="window.open(this.href, '_blank','width=1200, height=500, menubar=no, status=no')" target='_blank'>${responder}</a>`;

        const historyMsgType = `history_acvt_type_evtty030_${msgType}`;

        switch (historyMsgType) {
            case 'history_acvt_type_evtty030_1':
                this.result.historyMsgType = 'MK.01573';  // 에스컬레이션 진행 단계가 변경되었습니다.{{btnLink}}<br> - 상태: 실행 {bfTime}회, 진행 {bfStage}단계 →  실행 {afTime}회, 진행 {afStage}단계 {{stageRpt}}
                break;
            case 'history_acvt_type_evtty030_2':
                this.result.historyMsgType = 'MK.01574';  // 에스컬레이션 최종 알림{{btnLink}} <br> - 최종 알림: 단계별 알림 이후 모든 응답자에게 알림이 {{repeat}}회 전송되었습니다.
                break;
            case 'history_acvt_type_evtty030_3':
                this.result.historyMsgType = 'MK.00920';  // 에스컬레이션이 종료되었습니다.  (cf. 중지/종료 구분 없이 종료로 표시)
                break;
            case 'history_acvt_type_evtty030_4':
                this.result.historyMsgType = 'MK.00920';  // 에스컬레이션이 종료되었습니다.
                break;
        }

        this.result.params = {
            btnLink: btnLink,
            bfTime: bfTimeCnt,
            bfStage: bfStageCnt,
            afTime: afTimeCnt,
            afStage: afStageCnt,
            stageRpt: stageRepeat,
            repeat: repeatCnt
        };

        return this.result;
    };
    /* Incident Created (Auto) */
    EVTTY040 = function() {
        const chTypeCd = _.find(this.histDtl, ['MDF_FILD_NM', 'CH_TYPE_CD']);
        const methodStr = chTypeCd === undefined ? '' : (this.langCd === 'zh' ? `<strong>[${chTypeCd['MDF_AF_SBST_NM']}]</strong>` : ` <strong>[${chTypeCd['MDF_AF_SBST_NM']}]</strong>`);
        const responder = this.translate.instant('MK.00978');
        let btnLink = `<a href='/popup/escalation-policy-responders`;
            btnLink += `?tckNo=${this.data.trgtTcktNo}&tcktActvHistNo=${this.data.tcktActvHistNo}&companyId=${global['loginUser']['curCmpnId']}')`;
            btnLink += `onclick="window.open(this.href, '_blank','width=1200, height=500, menubar=no, status=no')" target='_blank'>${responder}</a>`;
        const addCntnt = `${methodStr}${btnLink}`;

        this.result.historyMsgType = 'MK.01572'; // 인시던트가 생성되었습니다. - {{method}} [응답자 버튼]
        this.result.params = {
            addCntnt: addCntnt
        };
        return this.result;
    };
    /* Registered Escalation Member */
    EVTTY050 = function() {  // TODO : 현재 사용되지 않는 타입인 듯 삭제?
        this.result.historyMsgType = 'MK.00668';
        return this.result;
    };
    /* Incident Created (Manual) */
    EVTTY060 = function() {
        const regrNm = this.data.regrNm;
        let msgType = '';
        let rspdNm;

        // 1.담당자를 등록한경우
        const userNo = _.find(this.histDtl, ['MDF_FILD_NM', 'USER_NO']);

        // 2.본인을 담당자로 등록하여 에스컬레이션이 동작하지 않은경우........
        const escalPlyActvTypeCd = _.find(this.histDtl, ['MDF_FILD_NM', 'ESCAL_PLY_ACTV_TYPE_CD']);
        const stopEscalation = _.find(this.histDtl, ['MDF_AF_SBST', 'STOP_ESCALATION']);

        if (userNo) {
            msgType = '2';
            rspdNm = userNo['MDF_AF_SBST_NM'];
            if (escalPlyActvTypeCd && stopEscalation) {
                msgType = '3';
            }
        } else {
            msgType = '1';
        }

        const chTypeCd = _.find(this.histDtl, ['MDF_FILD_NM', 'CH_TYPE_CD']);
        const methodStr = chTypeCd === undefined ? '' : (this.langCd === 'zh' ? `<strong>[${chTypeCd['MDF_AF_SBST_NM']}]</strong>` : ` <strong>[${chTypeCd['MDF_AF_SBST_NM']}]</strong>`);
        const rspdStr = this.translate.instant('MK.01576', {'rspdNm': rspdNm});
        const escalCloseStr = this.translate.instant('MK.01579');
        const responder = this.translate.instant('MK.00978');
        let btnLink = `<a href='/popup/escalation-policy-responders`;
            btnLink += `?tckNo=${this.data.trgtTcktNo}&tcktActvHistNo=${this.data.tcktActvHistNo}&companyId=${global['loginUser']['curCmpnId']}')`;
            btnLink += `onclick="window.open(this.href, '_blank','width=1200, height=500, menubar=no, status=no')" target='_blank'>${responder}</a>`;
        let addCntnt = '';

        const historyMsgType = `history_acvt_type_evtty060_${msgType}`;
        switch (historyMsgType) {
            case 'history_acvt_type_evtty060_1': // {{regrNm}} 님이 인시던트를 생성했습니다. - {{method}} [응답자 버튼]
                addCntnt = `${methodStr}${btnLink}`;
                break;
            case 'history_acvt_type_evtty060_2': // {{regrNm}} 님이 인시던트를 생성했습니다. - {{method}} [응답자 버튼] <br> - 담당자: {{rspdNm}}
                addCntnt = `${methodStr}${btnLink}<br>${rspdStr}`;
                break;
            case 'history_acvt_type_evtty060_3': // {{regrNm}} 님이 인시던트를 생성했습니다. - {{method}} [응답자 버튼] <br> - 담당자: {{rspdNm}} <br> - 에스컬레이션 실행: 종료
                addCntnt = `${methodStr}${btnLink}<br>${rspdStr}<br>${escalCloseStr}`;
                break;
        }

        this.result.historyMsgType = 'MK.01567';
        this.result.params = {
            regrNm: regrNm,
            addCntnt: addCntnt
        };

        return this.result;
    };
    /* Add Comment */
    EVTTY070 = function() {
        if(this.data.regrNo === 1){
            this.data.textSbst = this.unescapeHtml(this.data.textSbst);
        }
        this.result.params = {regrNm: this.data.regrNm, comment: this.data.textSbst.replace(/\\"/g, '"')};
        this.result.historyMsgType = 'MK.01566';
    };
    /* Merge Incident */
    EVTTY080 = function() {
        const regrNm = this.data.regrNm;

        // 종속 인시던트
        /*let mergedInctNm = '-';
        this.histDtl.forEach(item => {
            mergedInctNm += ` #${item.MDF_AF_SBST_NM},`;
        });*/

        this.result.historyMsgType = 'MK.01541';
        this.result.params = {
            regrNm: regrNm/*,
            mergedInctNm: mergedInctNm.substr(0, mergedInctNm.length - 1)*/
        };

        return this.result;
    };
    /* Merged into Incident */
    EVTTY090 = function() {
        const regrNm = this.data.regrNm;

        // 상태 변경
        let status1 = '';
        let status2 = '';
        const wrkflwStepNo = _.find(this.histDtl, ['MDF_FILD_NM', 'WRKFLW_STEP_NO']);
        if (wrkflwStepNo) {
            status1 = wrkflwStepNo['MDF_BF_SBST_NM'];
            status2 = wrkflwStepNo['MDF_AF_SBST_NM'];
        }

        // 기준 인시던트
        let basedInctNm = '';
        const tcktNoAdd = _.find(this.histDtl, ['MDF_FILD_NM', 'TCKT_NO_ADD']);
        if (tcktNoAdd) {
            basedInctNm = tcktNoAdd['MDF_AF_SBST_NM'];
        }

        const chTypeCd = _.find(this.histDtl, ['MDF_FILD_NM', 'CH_TYPE_CD']);
        const methodStr = chTypeCd === undefined ? '' : (this.langCd === 'zh' ? `<strong>[${chTypeCd['MDF_AF_SBST_NM']}]</strong>` : ` <strong>[${chTypeCd['MDF_AF_SBST_NM']}]</strong>`);
        const responder = this.translate.instant('MK.00978');
        let btnLink = `<a href='/popup/escalation-policy-responders`;
        btnLink += `?tckNo=${this.data.trgtTcktNo}&tcktActvHistNo=${this.data.tcktActvHistNo}&companyId=${global['loginUser']['curCmpnId']}')`;
        btnLink += `onclick="window.open(this.href, '_blank','width=1200, height=500, menubar=no, status=no')" target='_blank'>${responder}</a>`;
        const statusStr = this.translate.instant('MK.01578', {'status1': status1, 'status2': status2});
        const basedInctStr = this.translate.instant('MK.01580', {'basedInctNm': `#${basedInctNm}`});

        // {{regrNm}} 님에 의해 인시던트에 병합되었습니다. {{methodStr}}{{btnLink}} <br> - 상태: {{status1}} → {{status2}} <br> - 기준 인시던트: {{basedInctNm}}
        const addCntnt = `${methodStr}${btnLink}<br>${statusStr}<br>${basedInctStr}`;

        this.result.historyMsgType = 'MK.01575';
        this.result.params = {
            regrNm: regrNm,
            addCntnt: addCntnt
        };

        return this.result;
    };
    /* Related Incident Create */
    EVTTY100 = function() {
        this.result.historyMsgType = 'MK.01539';

        const regrNm = this.data.regrNm;

        // 추가된 관련 인시던트
        let relatedInctNm = `<em class="icon">${this.translate.instant('MK.01632')}</em>`;
        this.histDtl.forEach(item => {
            relatedInctNm += ` #${item.MDF_AF_SBST_NM},`;
        });

        this.result.params = {
            regrNm: regrNm,
            relatedInctNm: relatedInctNm.substr(0, relatedInctNm.length - 1)
        };

        return this.result;
    };
    /* Related Incident Modify */
    EVTTY110 = function() {
        this.result.historyMsgType = 'MK.01540';

        const regrNm = this.data.regrNm;

        // 수정된 관련 인시던트 (추가/삭제)
        let relatedInctNm = '';
        let addedInctNm = `<em class="icon">${this.translate.instant('MK.01632')}</em>`;
        let removedInctNm = `<em class="icon">${this.translate.instant('CD.CMSTAT30')}</em>`;
        this.histDtl.forEach(item => {
            if (item.MDF_FILD_NM === 'TCKT_NO_ADD') {
                addedInctNm += ` #${item.MDF_AF_SBST_NM},`;
            } else if (item.MDF_FILD_NM === 'TCKT_NO_DEL') {
                removedInctNm += ` #<del>${item.MDF_BF_SBST_NM}</del>,`;
                // removedInctNm += `<em class="icon">${this.translate.instant('CD.CMSTAT30')}</em><del>${item.MDF_BF_SBST_NM}</del><br>`;
            }
        });
        if (!removedInctNm.endsWith('</em>')) {
            relatedInctNm += removedInctNm.substr(0, removedInctNm.length - 1);
        }
        if (!addedInctNm.endsWith('</em>')) {
            relatedInctNm += !removedInctNm.endsWith('</em>') ? `<br>${addedInctNm.substr(0, addedInctNm.length - 1)}` : addedInctNm.substr(0, addedInctNm.length - 1);
        }
        this.result.params = {
            regrNm: regrNm,
            relatedInctNm: relatedInctNm
        };

        return this.result;
    };
    /* Modify Incident Urgency */
    EVTTY120 = function() {
        // {{user}} 님이 긴급도를 변경했습니다.
        // - 긴급도: {{urgency1}} → {{urgency2}}
        this.result.historyMsgType = 'MK.01626';

        let urgency1 = '';
        let urgency2 = '';
        const tcktPriNo = _.find(this.histDtl, ['MDF_FILD_NM', 'TCKT_PRI_NO']);

        if (tcktPriNo) {
            urgency1 = tcktPriNo['MDF_BF_SBST_NM'];
            urgency2 = tcktPriNo['MDF_AF_SBST_NM'];
        }

        this.result.params = {
            userNm: this.data.regrNm,
            urgency1: urgency1,
            urgency2: urgency2
        };

        return this.result;
    };
    /* Modify Incident Name */
    EVTTY140 = function() {
        // {{user}} 님이 이름을 변경했습니다.
        // - 이름: {{name1}} → {{name2}}
        this.result.historyMsgType = 'MK.01972';

        let name1 = '';
        let name2 = '';
        const tcktPriNo = _.find(this.histDtl, ['MDF_FILD_NM', 'TCKT_SMRY_SBST']);

        if (tcktPriNo) {
            name1 = tcktPriNo['MDF_BF_SBST_NM'];
            name2 = tcktPriNo['MDF_AF_SBST_NM'];
        }

        this.result.params = {
            userNm: this.data.regrNm,
            name1,
            name2
        };

        return this.result;
    };

    EVTTYI10 = function() {
        const itgrNo = _.find(this.histDtl, ['MDF_FILD_NM', 'ITGR_APPL_INSTL_NO']);
        if(itgrNo !== undefined) {
            const act = this;
            return new Promise(resolve => {
                let itgrType;
                act.integration.getIntegration(itgrNo['MDF_AF_SBST'], itgrType).then(result => {
                    if (result.status === 200) {
                        let integrationInfo = result.json().data;
                        let dispNm = integrationInfo.itgrApplDispNm+'('+_.unescape(integrationInfo.dispNm)+')';

                        const histEventType = this.translate.instant(EventType.CREATE_ISSUE);
                        let histMsgType = '';

                        const httpStatus = _.find(this.histDtl, ['MDF_FILD_NM', 'HTTP_STATUS']);
                        if (httpStatus['MDF_AF_SBST'] && httpStatus['MDF_AF_SBST'].substring(0, 3) === '200') {
                            const issueKey = _.find(act.histDtl, ['MDF_FILD_NM', 'ISSUE_KEY']);
                            histMsgType = this.translate.instant('MK.01957', {'itgrApplDispNm': dispNm, 'histEventType': histEventType, 'issueKey': issueKey['MDF_AF_SBST']});
                        } else {
                            let errorMsg = _.find(this.histDtl, ['MDF_FILD_NM', 'ERROR_MESSAGES']);
                            const errorMsgKey = _.find(this.histDtl, ['MDF_FILD_NM', 'ERROR_MSG_KEY']);
                            if (typeof errorMsgKey !== 'undefined') {
                                errorMsg = this.translate.instant(String(errorMsgKey['MDF_AF_SBST']));
                            } else {
                                errorMsg = errorMsg['MDF_AF_SBST'];
                            }

                            histMsgType = this.translate.instant('MK.01940', {'itgrApplDispNm': dispNm, 'histEventType': histEventType, 'errMsg': errorMsg});
                        }

                        act.result.historyMsgType = histMsgType;
                        resolve(histMsgType);
                    }
                });
            });
        } else {
            this.checkType(EventType.CREATE_ISSUE);
        }
    };

    EVTTYI20 = function () {
        const itgrNo = _.find(this.histDtl, ['MDF_FILD_NM', 'ITGR_APPL_INSTL_NO']);
        if (itgrNo !== undefined) {
            const act = this;
            return new Promise(resolve => {
                let itgrType;
                act.integration.getIntegration(itgrNo['MDF_AF_SBST'], itgrType).then(result => {
                    if (result.status === 200) {
                        let integrationInfo = result.json().data;
                        let dispNm = integrationInfo.itgrApplDispNm + '(' + _.unescape(integrationInfo.dispNm) + ')';

                        const histEventType = this.translate.instant(EventType.RESOLVE_ISSUE);
                        const issueKey = _.find(act.histDtl, ['MDF_FILD_NM', 'ISSUE_KEY']);
                        const histMsgType = this.translate.instant('MK.01957', { 'itgrApplDispNm': dispNm, 'histEventType': histEventType, 'issueKey': issueKey['MDF_AF_SBST'] });
                        act.result.historyMsgType = histMsgType;
                        resolve(histMsgType);
                    }
                });
            });
        } else {
            this.checkType(EventType.RESOLVE_ISSUE);
        }
    };

    EVTTYI30 = function() {
        const itgrNo = _.find(this.histDtl, ['MDF_FILD_NM', 'ITGR_APPL_INSTL_NO']);
        if(itgrNo !== undefined) {
            const act = this;
            return new Promise(resolve => {
                let itgrType;
                act.integration.getIntegration(itgrNo['MDF_AF_SBST'], itgrType).then(result => {
                    if (result.status === 200) {
                        let integrationInfo = result.json().data;
                        let dispNm = integrationInfo.itgrApplDispNm+'('+_.unescape(integrationInfo.dispNm)+')';

                        const histEventType = this.translate.instant(EventType.ADD_COMMENT);
                        const issueKey = _.find(act.histDtl, ['MDF_FILD_NM', 'ISSUE_KEY']);
                        const histMsgType = this.translate.instant('MK.01957', {'itgrApplDispNm': dispNm, 'histEventType': histEventType, 'issueKey': issueKey['MDF_AF_SBST']});
                        act.result.historyMsgType = histMsgType;
                        resolve(histMsgType);
                    }
                });
            });
        } else {
            this.checkType(EventType.ADD_COMMENT);
        }
    };

    EVTTYI40 = function () {
        const itgrNo = _.find(this.histDtl, ['MDF_FILD_NM', 'ITGR_APPL_INSTL_NO']);
        if (itgrNo !== undefined) {
            const act = this;
            return new Promise(resolve => {
                let itgrType;
                act.integration.getIntegration(itgrNo['MDF_AF_SBST'], itgrType).then(result => {
                    if (result.status === 200) {
                        let integrationInfo = result.json().data;
                        let dispNm = integrationInfo.itgrApplDispNm + '(' + _.unescape(integrationInfo.dispNm) + ')';

                        const histEventType = this.translate.instant(EventType.IN_PROGRESS_ISSUE);
                        const issueKey = _.find(act.histDtl, ['MDF_FILD_NM', 'ISSUE_KEY']);
                        const histMsgType = this.translate.instant('MK.01957', { 'itgrApplDispNm': dispNm, 'histEventType': histEventType, 'issueKey': issueKey['MDF_AF_SBST'] });
                        act.result.historyMsgType = histMsgType;
                        resolve(histMsgType);
                    }
                });
            });
        } else {
            this.checkType(EventType.IN_PROGRESS_ISSUE);
        }
    };

    EVTTYI50 = function() {
        this.checkType(EventType.RESOLVE_TICKET);
    };

    EVTTYI60 = function() {
        this.checkType(EventType.CLOSE_TICKET);
    };

    EVTTYI70 = function() {
        this.checkType(EventType.ADD_NOTE);
    };

    checkType(eventType) {
        const histEventType = this.translate.instant(eventType);

        let histMsgType = '';
        let errorMsg = _.find(this.histDtl, ['MDF_FILD_NM', 'ERROR_MESSAGES']);
        const errorMsgKey = _.find(this.histDtl, ['MDF_FILD_NM', 'ERROR_MSG_KEY']);
        const httpStatus = _.find(this.histDtl, ['MDF_FILD_NM', 'HTTP_STATUS']);

        if (typeof httpStatus !== 'undefined') {
            if (httpStatus['MDF_AF_SBST'] && httpStatus['MDF_AF_SBST'].substring(0, 3) === '200') {
                histMsgType = this.translate.instant('MK.01939', {'itgrApplDispNm': this.itgrApplDispNm, 'histEventType': histEventType});
            } else {
                if (typeof errorMsgKey !== 'undefined') {
                    errorMsg = this.translate.instant(String(errorMsgKey['MDF_AF_SBST']));
                } else {
                    errorMsg = errorMsg['MDF_AF_SBST'];
                }
                histMsgType = this.translate.instant('MK.01940', {'itgrApplDispNm': this.itgrApplDispNm, 'histEventType': histEventType, 'errMsg': errorMsg});
            }
        }

        this.result.historyMsgType = histMsgType;
    };

    unescapeHtml(str) {
        if (str == null) {
            return '';
        }
        return str
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#039;/g, '\'')
            .replace(/&#39;/g, '\'');
    }


    EVTTYR010 = function () {
        this.result.params = { regrNm: this.data.regrNm, comment: this.data.textSbst };
        this.result.historyMsgType = 'MK.02105';
    };

    EVTTYR020 = function () {
        this.result.params = { comment: this.data.textSbst };
        this.result.historyMsgType = 'MK.02106';
    }

    EVTTYR030 = function () {
        this.result.params = { comment: this.data.textSbst };
        this.result.historyMsgType = 'MK.02089';
    }

    EVTTYR040 = function () {
        this.result.params = { comment: this.data.textSbst };
        this.result.historyMsgType = 'MK.02090';
    }

    EVTTYR050 = function () {
        this.result.params = {comment: this.data.textSbst };
        this.result.historyMsgType = 'MK.02091';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/activity-history/activity-history.component.ts